<template>
  <v-card flat tile>
    <v-card-title>Shareholders</v-card-title>

    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="adminAssetHistory.shareholderInfo"
        class="mb-12 elevation-1"
        no-data-text="There is no shareholder history."
      >
        <template v-slot:item.amountPaid="{ item }">
          {{ item.amountPaid | numberToMoney }}
        </template>

        <template v-slot:item.payoutAmount="{ item }">
          {{ item.payoutAmount | numberToMoney }}
        </template>

        <template v-slot:item.roi="{ item }">
          {{ item.roi }}% ROI
        </template>
      </v-data-table>
    </v-card-text>

  </v-card>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AssetShareholders',

    computed: {
      ...mapGetters([
        'adminAssetHistory'
      ])
    },

    data: () => ({
      investments: [],

      headers: [
        {
          text: 'User Id',
          value: 'userId'
        },
        {
          text: 'Email',
          value: 'userEmailAddress'
        },
        {
          text: 'Full Name',
          value: 'userFullName'
        },
        {
          text: 'Shares Purchased',
          value: 'sharesPurchased'
        },
        {
          text: 'Amount Paid',
          value: 'amountPaid'
        },
        {
          text: 'Payout Amount',
          value: 'payoutAmount'
        },
        {
          text: 'ROI',
          value: 'roi'
        }
      ]
    }),
  }
</script>
